import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ spacing, breakpoints }) =>
  createStyles({
    shoppingCartContainer: {
      display: 'flex',
      height: 180,
      marginBottom: spacing(2)
    },
    cardMedia: {
      width: '30%',
      marginLeft: 40,
      marginRight: 40,
      height: '100%',
      backgroundSize: 'contain',
      [breakpoints.down('sm')]: {
        width: '50%',
        marginLeft: 10,
        marginRight: 10,
        marginTop: 0
      },
    },
    cardContent: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',

      '& .productDetails': {
        paddingTop: '0',
        paddingRight: '0',
        [breakpoints.down('md')]: {
          paddingTop: '35px',
          paddingRight: '35px'
        }
      },

      '& .qtyButtons': {
        [breakpoints.down('md')]: {
          paddingRight: '35px'
        }
      },

      '& .delete-icon-container': {
        [breakpoints.down('sm')]: {
          position: 'absolute',
          top: 0,
          right: 0,
          padding: 0
        },
      },

      '& .delete-icon': {
        color: '#D32F2F',
        alignSelf: 'flex-start'
      },

      '& .product-price': {
        color: 'gray'
      },

      [breakpoints.down('sm')]: {
        padding: 0,
        '& p': {
          fontSize: '16px',
          textAlign: 'center'
        }
      }
    },
    orderSummaryContainer: {
      alignSelf: 'flex-start',
      position: 'sticky',
      top: '5rem',

      '& div': {
        width: '100%',
        padding: '5px',
        border: 'none',
        boxShadow: 'none'
      },
      '& button': {
        backgroundColor: '#D32F2F',
        marginTop: '10px',
        width: '100%'
      },
      '& .total-label': {
        color: 'gray',
        marginRight: '10px'
      },
      '& .total-price': {
        color: '#D32F2F',
        fontWeight: '700'
      }
    },
    arrowBack: {
      color: 'black'
    },
    shoppingCartTitle: {
      textAlign: 'center',
      [breakpoints.down('md')]: {
        fontSize: '1.5rem'
      }
    }
  })
);